import { render, staticRenderFns } from "./day.vue?vue&type=template&id=124e106b&scoped=true&"
import script from "./day.vue?vue&type=script&lang=js&"
export * from "./day.vue?vue&type=script&lang=js&"
import style0 from "./day.vue?vue&type=style&index=0&id=124e106b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e106b",
  null
  
)

export default component.exports